<template>
  <div style="min-height: 240px;">
    <div class="chart-title">Equity</div>
    <div v-if="!hideSettings" class="settings-button">
      <miniSettings :position="position" :minis="minis" />
    </div>
    <apexchart
      class="mb-4"
      v-if="data != null"
      ref="minichartEquity"
      type="line"
      :options="chartOptions"
      :series="series"
    ></apexchart>
    <div class="width-full float-left text-center text-grey no-trades" v-else>NO TRADES</div>
  </div>
</template>

<script>
import miniSettings from "./miniSettings";
export default {
  name: "MiniEquity",
  components: { miniSettings },
  props: ["data", "source", "hideSettings"],
  data() {
    return {
      miniType: { Strategies: "minichartsStrategy", Tags: "minichartsTag" },
      equity: [],
      chartOptions: {
        xaxis: {
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          enabled: false
        },
        grid: {
          show: false
        },
        colors: ["#79C04D"],
        chart: {
          toolbar: {
            show: false
          }
        },
        stroke: {
          show: true,
          //curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 3,
          dashArray: 0
        }
      },
      series: [{ data: this.equity }]
    };
  },
  watch: {
    data: function() {
      
      this.equity = [];
      if (this.source == "direct") {
        this.directData();
      }else if(this.source == "trades"){
        this.tradeData()
      } else {
        this.equityData();
      }
    }
  },
  mounted() {
    if (this.source == "direct") {
      this.directData();
    }else if(this.source == "trades"){
      this.tradeData()
    } else {
      this.equityData();
    }
  },
  methods: {
    equityData() {
      var sum = 0;
      if (this.data)
        this.data.pl.forEach(pl => {
          sum += pl;
          this.equity.push(sum);
        });
      this.$refs.minichartEquity.updateSeries([{ data: this.equity }]);
      this.colorSet(this.equity[this.equity.length - 1]);
    },
    tradeData() {
      var sum = 0;
      if (this.data)
        this.data.forEach(trade => {
          sum += trade.ClosedProfitLoss;
          this.equity.push(sum);
        });
      this.$refs.minichartEquity.updateSeries([{ data: this.equity }]);
      this.colorSet(this.equity[this.equity.length - 1]);
    },
    directData() {
      this.$refs.minichartEquity.updateSeries([{ data: this.data }]);
      this.colorSet(this.data[this.data.length - 1]);
    },
    colorSet(val) {
      if (val > 0) {
        // green
        this.$refs.minichartEquity.updateOptions({ colors: ["#79C04D"] });
      } else {
        //red
        this.$refs.minichartEquity.updateOptions({ colors: ["#E62163"] });
      }
    }
  }
};
</script>

<style>
</style>